import { Button, DialogContentText, Stack, Alert, Typography, useMediaQuery } from '@mui/material'
import { useState } from 'react'
import { pagesPath } from '~/lib/$path'
import TurnLeftIcon from '@mui/icons-material/TurnLeft'
import WarningIcon from '@mui/icons-material/Warning'
import { theme } from '~/lib/theme'
import { SimpleDialog } from '~/components/common/SimpleDialog'
import { useRouter } from 'next/router'

export const HomeButtons = () => {
  const [open, setOpen] = useState(false)
  const router = useRouter()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const handleClickOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  // 900px以下では非表示
  if (isMobile) return null

  return (
    <>
      <Stack
        direction="row"
        sx={{
          position: 'fixed',
          bottom: 20,
          left: 20,
        }}
      >
        <Button variant="text" onClick={handleClickOpen}>
          <TurnLeftIcon />
          ホームに戻る
        </Button>
      </Stack>

      <SimpleDialog
        open={open}
        title="ホームに戻ってよろしいですか?"
        okButtonText="ホームに戻る"
        closeButtonText="編集を続ける"
        onClose={handleClose}
        onOk={() => {
          router.push(pagesPath.home.$url().pathname)
        }}
        onCancel={() => {
          handleClose()
        }}
      >
        <DialogContentText id="alert-dialog-description">
          <Alert severity="warning" icon={<WarningIcon />} sx={{ my: 1 }}>
            <Typography variant="body2" mb={1}>
              現在入力中の内容は保存されません。
            </Typography>
            <Typography variant="body2">このままホームに戻ると、すべての入力内容が失われます。</Typography>
          </Alert>
        </DialogContentText>
      </SimpleDialog>
    </>
  )
}
